/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { bulkUpdateAssets, clearError, getHostsData, loadHostDetail, resetState } from 'store/HostsGeneral/actions';
import { Wrapper, TableContainer } from './styled';
import Table from './components/Table';
import ActionBar from './components/ActionBar';
import { MODAL_CANT_CREATE, MODAL_UPGRADE_LICENSE_ACTION_BAR } from 'store/modals/modals';
import ReduxModal from 'Common/Components/ReduxModal';
import UpgradeLicense from 'Common/Components/UpgradeLicense';
import HostModalCreate from 'Screens/Contextualization/HostModalCreate';
import { getCustomFilters, resetFilters } from 'store/Filters/actions';
import { hideHostDetail } from 'store/HostDetail/actions';
import HostDetail from 'Screens/Contextualization/Host/components/HostDetail';
import FilterSideBar from 'Screens/Contextualization/Manage/components/FilterSideBar';
import { selectError, selectErrorMessage, selectHostGeneralCount, selectHostsSelected, selectIsFetching, selectModalBulkUpdateValue, selectSelectAllHosts, selectShowRightFilters } from 'store/HostsGeneral/selectors';
import ErrorDialog from 'Common/Components/ErrorDialog';
import WarningModal from 'Screens/Contextualization/ManageEditCreate/components/WarningModal';
import { selectActiveWorkspacesCount } from 'store/Global/selectors';
import selectModal from 'store/modals/selectors';
import AssetsContextMenu from './components/Table/ContextMenu';
import SelectAll from './components/SelectAll';
import BulkUpdateModal from './components/Table/components/BulkUpdateModal';
import BulkUpdateConfirmationDialog from '../Manage/components/ManageTable/components/BulkUpdateConfirmationDialog';
import { getWorkspacesData } from 'store/Global/actions';
import ImportFileCreationModal from 'Screens/Contextualization/ManageEditCreate/components/ImportFileCreationModal';

const HostsGeneral = ({ params }) => {
  const dispatch = useDispatch();
  const [FFImage, setFFImage] = useState(null);
  const [FFDescription, setFFDescription] = useState('');
  const [showImportModal, setShowImportModal] = useState(false);
  const showRightFilters = useSelector(selectShowRightFilters);
  const error = useSelector(selectError);
  const errorMessage = useSelector(selectErrorMessage);
  const showModalCantCreate = useSelector((state) => selectModal(state, MODAL_CANT_CREATE));
  const activeWorkspacesCount = useSelector(selectActiveWorkspacesCount);
  const hostsSelected = useSelector(selectHostsSelected);
  const count = useSelector(selectHostGeneralCount);
  const selectAll = useSelector(selectSelectAllHosts);
  const isFetching = useSelector(selectIsFetching);
  const bulkUpdateValue = useSelector(selectModalBulkUpdateValue);

  const handleParamId = useCallback(() => {
    const id = get(params, 'id', 0);
    if (parseInt(id, 10) > 0) dispatch(loadHostDetail(id));
    else dispatch(hideHostDetail());
  }, [params]);

  useEffect(() => {
    dispatch(getCustomFilters());
  }, [showRightFilters, dispatch]);

  useEffect(() => {
    dispatch(getHostsData());
    dispatch(getWorkspacesData(false, false));
  }, []);

  useEffect(() => {
    handleParamId();
  }, [handleParamId]);

  useEffect(() => () => {
    dispatch(resetState());
    dispatch(resetFilters('assetsGeneral'));
  }, [dispatch]);

  const handleDragEnter = (e) => {
    if (e.dataTransfer && e.dataTransfer.types && e.dataTransfer.types.includes('Files')) {
      setShowImportModal(true);
    }
  };

  const handleDragOver = (e) => { e.preventDefault(); };

  const setFF = (image, description) => {
    setFFImage(image);
    setFFDescription(description);
  };

  return (
    <Wrapper onDragEnter={ handleDragEnter } onDragOver={ handleDragOver }>
      <ActionBar setFF={ setFF } />
      <ReduxModal id={ MODAL_UPGRADE_LICENSE_ACTION_BAR }>
        <UpgradeLicense id={ MODAL_UPGRADE_LICENSE_ACTION_BAR } image={ FFImage } descriptionIntlId={ FFDescription } />
      </ReduxModal>
      <HostModalCreate assetsGeneral />
      <SelectAll />
      <TableContainer>
        <Table />
        <HostDetail assetsGeneral />
        <FilterSideBar entity="assetsGeneral" />
        <AssetsContextMenu />
        <BulkUpdateModal />
        <BulkUpdateConfirmationDialog
          selected={ hostsSelected }
          count={ count }
          isSelectAll={ selectAll }
          isFetching={ isFetching }
          bulkUpdateValue={ bulkUpdateValue }
          bulkUpdateAction={ bulkUpdateAssets }
          title="Assets"
        />
      </TableContainer>
      { error ? <ErrorDialog message={ errorMessage } resetError={ () => dispatch(clearError()) } /> : null }
      { showModalCantCreate && <WarningModal entity="Asset" noWorkspaces={ !activeWorkspacesCount } /> }
      <ImportFileCreationModal show={ showImportModal } handleClose={ () => setShowImportModal(false) } entity="vulnsGeneral" />
    </Wrapper>
  );
};

export default HostsGeneral;
